import { Navigate, Outlet } from "react-router-dom";
import BusyIndicatorHTML from "../components/BusyIndicator/BusyIndicatorHTML";
import { RoutePath } from "../constants/RoutePath";
import { useTenant } from "./useTenant";

export default function RequireTenantSetup() {
  const { Status } = useTenant();

  if (Status === "Initializing") {
    return (
      <BusyIndicatorHTML
        isOpen
        mode="overlay"
        message="Checking tenant setup..."
      />
    );
  }

  return Status === "NotFound" ? (
    <Outlet />
  ) : (
    <Navigate to={RoutePath.Login} replace />
  );
}
